window.$ = window.jQuery = require('jquery');

import '@tabler/core';
import 'datatables.net';
import 'datatables.net-bs5';
import 'datatables.net-responsive';
import 'datatables.net-buttons';
import 'parsleyjs';

window.ApexCharts = require('apexcharts');
window.Timeago = require('timeago');
window.TomSelect = require('tom-select');
window.ClipboardJS = require('clipboard');

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key:         process.env.MIX_PUSHER_APP_KEY,
  cluster:     process.env.MIX_PUSHER_APP_CLUSTER,
  encrypted:   true
});
